// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__7AK_O","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1zjYB","obliqueLine":"membershipbadge_obliqueLine__3RCI-"};